import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@material-ui/core/Snackbar';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';

const SnackbarNowWrapper = styled.div`
  > div {
    padding: 0;
  }
  .content {
    background-color: #fff;
    padding: 0 !important;
    > div {
      padding: 0 !important;
    }
  }
  .message {
    display: flex;
    margin: 0 !important;
    padding: 0 !important;
    width: 100%;
    height: 100%;
  }
  .image {
    max-width: 200px;
  }
  .title {
    color: #000 !important;
  }
  .left {
    width: 50%;
    background: ${(props) => `url("${props.featuredImage}")`};
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .right {
    padding: 10px 10px 10px 20px;
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }
  .text {
    color: #000;
    max-width: 90%;
  }
`;

export const SnackbarComponent = ({ handleClose, handleGo, classes, open, imgSrc }) => (
  <SnackbarNowWrapper featuredImage={imgSrc}>
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      onClose={handleClose}
      onClick={handleGo}
      open={open}
    >
      <SnackbarContent
        className="content"
        message={
          <div className="message">
            <div className="left" />
            <div className="right" id="wamnow-message">
              <Typography variant="headline" className="title">
                Winner and a Movie Starts Now!
              </Typography>
              <Typography variant="subheading" className="text">
                Watch, play, chat and win!
              </Typography>
              <Typography className="actions">
                <Button key="stop" onClick={handleClose}>
                  Dismiss
                </Button>
                <Button key="go" color="primary" onClick={handleGo}>
                  Watch Now
                </Button>
              </Typography>
            </div>
          </div>
        }
      />
    </Snackbar>
  </SnackbarNowWrapper>
);

SnackbarComponent.propTypes = {
  handleClose: PropTypes.func.isRequired,
  handleGo: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  imgSrc: PropTypes.string.isRequired,
};
